import styled, { css } from 'styled-components';
import { inject } from 'mobx-react';
import chroma from 'chroma-js';

import { institutionLogoWidth } from 'js/config/style';

const animatedBackground = css`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${({ creditCard }) =>
    `linear-gradient(to right, ${creditCard.institution_color.brighten(1)} 8%, ${
      creditCard.institution_color
    } 18%, ${creditCard.institution_color.brighten(1)} 33%)`};
  background-size: 1000px 104px;
`;

const colorStyle = css`
  background: ${({ creditCard }) => creditCard.institution_color};
  color: white;
  padding-left: 1rem;
  border-radius: 0 0.25rem 0.25rem 0;
  border-left: ${({ creditCard }) => `1px solid ${creditCard.institution_color.darken()}`};
`;

export default inject('creditCard')(styled.div`
  position: relative;
  ${({ creditCard }) => creditCard.institution_color && colorStyle}
  ${({ isBusy }) => isBusy && animatedBackground}
  border: 1px solid ${({ creditCard }) => chroma(creditCard.institution_color).darken()};
  border-radius: 0.25rem;
  min-height: ${({ height }) => height}rem;
  display: grid;
  grid-template-columns: ${({ editor }) => (editor ? `${institutionLogoWidth} 1fr 2.5rem` : 'auto')}
`);
